module.exports = __webpack_public_path__ + "img/planet.093aa27d.svg";